import React,{useState} from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Avatars from "./Avatars";
import MenuBtn from './MenuBtn';
import Tooltip from '@material-ui/core/Tooltip';

// import RadioBtns from './RadioBtns';

// import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
// import Avatar from '@material-ui/core/Avatar';
const ProductViewHeader={
  borderBottom: "1px solid #c7c7c7",
  minHeight:"42px"
}



const MenuInterierView =(props)=>{
  
  const [open, setOpen] = React.useState(false);

  

  const handleOpen = () => {
    if(window.laptop == 'laptop180'){
      setOpen(true);
      // console.log('a')
    }
    else if(window.laptop == 'laptop360') {
      setOpen(false);
      // console.log('b')
    }
   
  };
  const handleClose = () => {
    setTimeout(() => {
      setOpen(false);
    }, 300);
  }

    return(
        <div className="Accordians">
         {/* <Tooltip id="tooltips" open={open}  onOpen={handleOpen} onClose={handleClose} title="Not available in selected product type"  placement="right" arrow> */}
         <Accordion style={{borderRadius:"0px"}} onChange={props.onChanged} expanded={props.expanded}>
        <AccordionSummary id="positionBtn" tabIndex="1"
          expandIcon={<ExpandMoreIcon />} style={ProductViewHeader}  onKeyPress={ props.onInterirorBtnClick} onClick={props.onInterirorBtnClick}>
            {/* <img  src="./img/interior.png" style={{width:"40px",height:"30px",paddingLeft: "2px",paddingTop: "2px"}}/> */}
        <Typography id="interiorText" className="accordion-headers AccordiansHeader" style={{fontWeight:"700"}}>{props.name}</Typography>
        </AccordionSummary>
        <AccordionDetails tabIndex="1" aria-label="Processor"  id="processorBtn" onKeyPress={ props.onProcessorBtnClick} onClick={props.onProcessorBtnClick}>
        <MenuBtn aria-hidden="true" submenu={window.finalLangues.port1P} source="./img/intel.svg"/>

        </AccordionDetails>  
        <AccordionDetails tabIndex="1" aria-label="Memory"  id="memoryBtn" onKeyPress={ props.onMemoryBtnClick} onClick={props.onMemoryBtnClick}>
        <MenuBtn aria-hidden="true" submenu={window.finalLangues.port2M} source="./img/interior.png"/>

        </AccordionDetails>  
        <AccordionDetails tabIndex="1" aria-label="Dynamic Media Enclosure"  id="DMEnclosure" onKeyPress={ props.onDMEnclosureClick} onClick={props.onDMEnclosureClick}>
        <MenuBtn aria-hidden="true" submenu={window.finalLangues.port3F} source="./img/DMEnclosure.png"/>

        </AccordionDetails>
        {/* <AccordionDetails tabIndex="1" aria-label="Tilt Screen 21°/-5°"  id="tiltScreenBtn" onKeyPress={ props.tiltScreenAnim} onClick={props.tiltScreenAnim}>
        <MenuBtn aria-hidden="true" submenu="Tilt Screen 21°/-5°blet" source={props.imgtilt}/>

        </AccordionDetails> */}
      </Accordion>
      {/* </Tooltip> */}
        </div>
    );
}

export default MenuInterierView;